import { useDealActions, useDealQueriesSelect } from "store";
import { PipelineViewConfig } from "store/types";

/**
 * Persists the WHOLE pipeline view config blob to `/user/settings` (the server stores it as one JSON value).
 * Any caller passes only the fields it changed; the rest are filled from the current deal queries so a partial
 * update never clobbers the other settings. Best-effort — live state is already updated via `updateQueries`.
 */
export const usePipelineConfigPersist = () => {
  const { updatePipelineViewConfigAction } = useDealActions();
  const {
    pipelineGroupBy,
    pipelineCardCharacteristics,
    pipelineCardCharacteristicOptions,
    pipelineHiddenStageIds,
    pipelineDiffView,
    pipelineDateRange
  } = useDealQueriesSelect();

  return (patch: Partial<PipelineViewConfig>) =>
    updatePipelineViewConfigAction({
      pipelineGroupBy: patch.pipelineGroupBy ?? pipelineGroupBy,
      pipelineCardCharacteristics: patch.pipelineCardCharacteristics ?? pipelineCardCharacteristics,
      pipelineCardCharacteristicOptions: patch.pipelineCardCharacteristicOptions ?? pipelineCardCharacteristicOptions,
      pipelineHiddenStageIds: patch.pipelineHiddenStageIds ?? pipelineHiddenStageIds,
      pipelineDiffView: patch.pipelineDiffView ?? pipelineDiffView,
      // null is a valid value (cleared range), so distinguish it from "not in the patch".
      pipelineDateRange: patch.pipelineDateRange !== undefined ? patch.pipelineDateRange : pipelineDateRange
    }).catch(() => undefined);
};
